/**
 * Download 첨부파일
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */
import React from 'react'

// css
import 'assets/style/elements/download-link.scss'
import { formatBytes } from 'utils/format-util'

function Element({
  children,
  className,
  text,
  size,
  remove = false,
  icon = false,
  onDownload = () => {},
  onDelete = () => {},
}) {
  const iconyn = [true, 'true'].includes(icon)
  if (iconyn) className += ' icon'

  return (
    <div className={'download-link ' + className}>
      <span className="text" onClick={onDownload} key={'text'}>
        {text || children}
        {size && ' (' + formatBytes(size) + ')'}
      </span>
      {iconyn && (
        <span className="remove" onClick={onDelete}>
          삭제
        </span>
      )}
    </div>
  )
}

export default Element
